'use strict';

var base = require('client_core/contact/contact');
var formErrors = require('base/checkout/formErrors');
var recaptcha = require('core/components/recaptcha');
base.formShowHide = function () {
  $('#contact-form').find('[name$=_assistance]').on('change', function (e) {
    var $selected = $(this).find(':selected');
    if ($('#contact-form.no-collapse').length < 1) {
      if ($selected.val()) {
        $('#contact-collapse').collapse('show');
      } else {
        $('#contact-collapse').collapse('hide');
      }
    }
  });
};
module.exports = base;